import {Feature} from 'acng/core/model/feature.js';

const featureName = 'locale';
export default featureName;
export const localeFeature = new Feature(featureName);
